// extracted by mini-css-extract-plugin
module.exports = {"blogPost":"article_blogPost__s5G9v","left":"article_left__DL9He","right":"article_right__yRJRw","inline":"article_inline__94Ue3"};